import _ from 'lodash';
import React, { Component, PropTypes } from 'react';

import LearningTimeAndTestScoreChart from './LearningTimeAndTestScoreChart';
import TestScoreHistogram from '../../../../utils/components/TestScoreHistogram';
import ErrorMessage from '../../../../utils/components/ErrorMessage';
import message from '../../../../../../../utils/message';

// 平均値などを小数点第何位まで表示するか
const TO_FIXED_NUM = 2;

class App extends Component {
  constructor(props) {
    super(props);

    const { data } = props;
    this.state = {
      selectedIndex: data.length >= 1 ? data[0].index : -1,
    };
  }

  changeSelector = (event) => {
    this.setState({
      selectedIndex: _.toNumber(event.target.value),
    });
  }

  render() {
    const { data } = this.props;
    const { selectedIndex } = this.state;

    if (selectedIndex === -1) {
      return (
        <ErrorMessage message={message.chartErrorMessage} />
      );
    }

    const selectedData = _.find(data, ({ index }) => index === selectedIndex).data;

    return (
      <div>
        <select value={selectedIndex} onChange={this.changeSelector}>
          {
            data.map(({ index, name }) => <option value={index} key={index}>{name}</option>)
          }
        </select>

        <LearningTimeAndTestScoreChart
          toFixedNum={TO_FIXED_NUM}
          data={selectedData}
        />
        <TestScoreHistogram
          toFixedNum={TO_FIXED_NUM}
          scores={selectedData.map(({ score }) => score)}
        />
      </div>
    );
  }
}
App.propTypes = {
  data: PropTypes.array.isRequired,
};

export default App;



// WEBPACK FOOTER //
// ./es6/admin-common-js/apps/csv_chart/charts/portfolio/analysis/components/App.js